"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  id: "01",
  title: "Custom Homes",
  description: "We bring visions to life with expert bricklaying and stonework, combining timeless craftsmanship with modern architectural design for your dream residence."
}, {
  id: "02",
  title: "Fireplaces",
  description: "Crafting stunning indoor fireplaces and outdoor cooking areas that blend beauty with functionality, tailored to enhance your home's comfort and value."
}, {
  id: "03",
  title: "Repair Work",
  description: "Expert restoration services for brick, stone, or blockwork. We match existing materials to ensure seamless results that maintain your structure's character."
}];
export default function TheMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233955" id="our-expertise" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 md:mb-24">
          <h2 className="font-default text-sm font-semibold tracking-widest uppercase text-primary mb-4">
            Our Expertise
          </h2>
          <p className="font-serif text-3xl md:text-5xl font-normal tracking-wider max-w-2xl leading-tight uppercase">
            Structural strength meets high-end masonry precision.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 lg:gap-16">
          {pillars.map((pillar, i) => <div key={pillar.id} data-index={i} className="relative group flex flex-col">
              <div className="absolute -top-10 -left-4 md:-top-16 md:-left-8 text-[8rem] md:text-[12rem] font-serif font-bold leading-none text-muted-foreground/10 select-none transition-colors duration-500 group-hover:text-primary/20 z-0">
                {pillar.id}
              </div>

              <div className="relative z-10 pt-12 md:pt-20">
                <h3 className="font-serif text-2xl md:text-3xl font-normal mb-6 tracking-wide uppercase">
                  {pillar.title}
                </h3>
                <div className="h-px w-12 bg-primary mb-6 transition-all duration-500 group-hover:w-full opacity-50 group-hover:opacity-100" />
                <p className="text-muted-foreground leading-relaxed font-default text-lg">
                  {pillar.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}